import type { PrometheusEndpointSuffix } from "instant-config";
import { getBooleanQueryParam } from "utils";

const canSendCache = new Map<PrometheusEndpointSuffix, boolean>();

/**
 * Checks the ICBM settings to determine the sample rate, then chooses whether to send this data or not
 *
 * (recommended): To override this setting, you can add the query parameter ?force_tracking=true
 * This will apply for all types of tracking sampling (Beacon and Prometheus)
 *
 * Alternately, you can override the icbm parameter directly like this:
 * ?icbm__odysseyPrometheusSenderTrafficLimiter={"NAME":VALUE}
 * e.g. to change the setting for the "time" endpoint to send 100% of the time, use this:
 *
 * ?icbm__odysseyPrometheusSenderTrafficLimiter={"time":100}
 *
 */
export function shouldSendToEndpoint(
  endpoint: PrometheusEndpointSuffix,
): boolean {
  if (getBooleanQueryParam("force_tracking")) {
    return true;
  }

  const cachedValue = canSendCache.get(endpoint);

  if (cachedValue !== undefined) {
    return cachedValue;
  }

  const thresholds = window.icbm?.config?.odysseyPrometheusSenderTrafficLimiter;
  if (thresholds?.[endpoint] === undefined) {
    canSendCache.set(endpoint, true);
    return true;
  }

  const isAllowed = Math.random() * 100 < thresholds[endpoint];

  canSendCache.set(endpoint, isAllowed);

  return isAllowed;
}
